import React, {lazy, Suspense} from 'react'

const SongsPageLazy = lazy(() =>
  import('./SongsPage').then((m) => ({default: m.SongsPage}))
)

const SongsPage = (props) => (
  <Suspense fallback={null}>
    <SongsPageLazy {...props}/>
  </Suspense>
)

export default SongsPage
